import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../utils/authContext';
import { loginApiCall } from '../../utils/apicall/authApi';
import { getUserData } from '../../utils/apicall/profileApi';
import { CONFIG } from '../../utils/config';
import { updateBodyClass } from '../../utils/function';
import { ApiError } from '../../utils/error/error';
import { processError } from '../../utils/error/errorUtils';
import ErrorMessage from '../../components/errorMessage';
import { authService } from '../../utils/authServices';


const Login: React.FC = () => {
  const navigate = useNavigate();
  const { isAuthenticated, loginauth } = useAuth();

  // Form state
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [loginError, setLoginError] = useState('');
  const [errorMessage, setErrorMessage] = useState<string | null>(null);
  const [errors, setErrors] = useState<{ [key: string]: string[] }>({});
  const [successMessage, setSuccessMessage] = useState<string | null>(null);

  // Add specific class to body on component mount
  useEffect(() => {
    updateBodyClass('auth-page');
    return () => updateBodyClass('');
  }, []);


  // Handle login form submission
  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    setEmailError('');
    setPasswordError('');
    setLoginError('');
  
    // Basic form validation
    if (!email) {
      setEmailError('Email is required');
      return;
    }
    if (!password) {
      setPasswordError('Password is required');
      return;
    }
  
    try {
      const response = await loginApiCall(email, password);
      if (response?.status === 200 && response.data?.token) {
        
          authService.setRawToken(response.data.token);
          authService.setTokenExpiration(response.data.expires_at);
          
          // Fetch user data
          const responseUserData = await getUserData();
          if (responseUserData?.status === 200) {
            await loginauth(responseUserData.data);
          // await refreshAuthToken ();
            navigate(CONFIG.urls.getDashboardUrl_Admin());
          } else {
            throw new Error('Failed to fetch user data');
          }
        } else {
          throw new Error('Invalid email or password');
        }

      
    } catch (error) {
       processError(error, setErrors, setErrorMessage, setSuccessMessage);
     /* if (error instanceof ApiError) {
        // Display the API error message
       // setLoginError(error.message || 'Invalid email or password');
        processError(error, setErrors, setErrorMessage, setSuccessMessage);
      } else {
        console.error('Login failed:', error);
       // setLoginError('An unknown error occurred. Please try again.');
        processError(error, setErrors, setErrorMessage, setSuccessMessage);
      }*/
    }
  };

  return (
    <div>
   
      <div className="container">
          
        <div className="row justify-content-center animated-fade">
       
          <div className="card p-5">
            {/* Title and Subtitle */}
            <div className="text-center mb-4">
              <h2 className="welcome-text">CONTACTO</h2>
              <p className="sub-text">Παρακαλούμε συνδεθείτε για να συνεχίσετε</p>
            </div>
            {/* Login Form */}
            <form onSubmit={handleLogin}>
              {/* Email Input */}
              <div className="mb-4">
                <label htmlFor="email" className="form-label visually-hidden">
                  Email
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-envelope"></i>
                  </span>
                  <input
                    type="email"
                    className="form-control"
                    id="email"
                    placeholder="Email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                </div>
              
                {errors && errors.hasOwnProperty('email') && (<ErrorMessage message={errors.email[0]} />)}
              </div>

              {/* Password Input */}
              <div className="mb-4">
                <label htmlFor="password" className="form-label visually-hidden">
                  Κωδικός
                </label>
                <div className="input-group">
                  <span className="input-group-text">
                    <i className="bi bi-lock"></i>
                  </span>
                  <input
                    type="password"
                    className="form-control"
                    id="password"
                    placeholder="Κωδικός"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                  />
                </div>
                {errors && errors.hasOwnProperty('password') && (<ErrorMessage message={errors.password[0]} />)}
              </div>

              {/* Submit Button */}
              <div className="d-grid">
                <button type="submit" className="btn btn-custom btn-lg">
                  Σύνδεση
                </button>
              </div>

              {/* Login Error */}
              {errorMessage && <div className="text-center mt-3 text-danger">{errorMessage}</div>}
             
              {/* Forgot Password Link
              <div className="text-center mt-3">
                <a href={CONFIG.urls.getResetPasswordUrl()} className="text-muted small">
                  Ξέχασες τον κωδικό σου;
                </a>
              </div> */}
            </form>
          </div>
        </div>
     
      </div>
      </div>
  );
};

export default Login;
